import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>PREPRAVNÝ PORIADOK cestnej nákladnej dopravy LUMIJO, s.r.o.</h1>
        <h2>Starý rad 155, 038 21 Mošovce</h2>
        <h3>1) Základné ustanovenia</h3>
        <p>
          1.1 Účelom vydania tohto Prepravného poriadku je popis rozsahu
          činností pri zabezpečovaní činnosti spoločnosti a stanovenie právomocí
          a zodpovedností pri preprave nákladu cestným nákladným vozidlom medzi
          právnickými osobami, fyzickými osobami podnikateľmi alebo fyzickými
          osobami - nepodnikateľmi zúčastnenými na preprave a stanovenie
          podmienok na uzavretie zmluvy o preprave nákladu a jej obsahu podľa §
          610 a nasl. zákona č. 513/1991 Zb. Obchodného zákonníka, v znení
          neskorších predpisov (ďalej len „Obchodný zákonník“), resp. § 765 a
          nasl. zákona č. 40/1964 Zb. Občianskeho zákonníka, v znení neskorších
          predpisov pokiaľ nejde o obchodno-záväzkový vzťah (ďalej len „Zmluva o
          preprave“).{" "}
        </p>
        <p>
          Prepravný poriadok neupravuje ceny a cenové podmienky. Podľa tohto
          prepravného poriadku Dopravca (ako je definovaný nižšie) vykonáva
          špeciálnu vnútroštátnu nákladnú cestnú dopravu – likvidácia odpadových
          vôd, ktoré nie sú vylúčené z prepravy podľa čl. 5 tohto Prepravného
          poriadku. 1.2 Dopravcom je LUMIJO, s.r.o. Starý rad 155, 038 21
          Mošovce, IČO: 51911230 (ďalej len „Dopravca“) v zmysle § 3 Zákona č.
          56/2012 Z. z. o cestnej doprave, v znení neskorších predpisov. 1.3
          Prepravou podľa Prepravného poriadku je premiestnenie odpadových vôd
          vo vnútroštátnej cestnej nákladnej doprave. 1.4 Prepravnou povinnosťou
          Dopravcu je povinnosť vykonať prepravu, ak sú splnené podmienky podľa
          tohto Prepravného poriadku a umožňujú to prepravné podmienky, najmä
          technický stav, vyťažiteľnosť vozidla, spôsobilosť vodiča a nebránia
          tomu príčiny, ktoré nemožno odvrátiť.
        </p>
        <p>
          2) Rozsah, charakter a druhy prepráv cestnej nákladnej dopravy 2.1
          Dopravca vykonáva len vnútroštátnu cestnú nákladnú dopravu. 2.2
          Charakter vykonávanej cestnej nákladnej dopravy – vývoz odpadových
          vôd. 2.4 O jednu jazdu vozidla ide aj vtedy , ak Dopravca z
          prevádzkových dôvodov ako je napr. porucha na vozidle dokončí jazdu v
          iný deň ako bolo dohodnuté.
        </p>
        <p>
          3). Spôsob uzavretia a platnosť zmluvy o preprave 3.1 Odosielateľ si u
          Dopravcu prepravu objednáva. Objednávku môže Odosielateľ vykonať u
          Dopravcu písomne, ústne, mailom alebo telefonicky. Ústnu alebo
          telefonickú objednávku odosielateľ potvrdí písomne, ak ho na to
          Dopravca vyzve. Ustanovenia o objednávke – Zmluve o preprave sa
          nepoužijú v prípadoch, ak má Dopravca s odosielateľom uzatvorenú
          rámcovú zmluvu o preprave. 3.2 Objednávka prepravy podľa ods. 1 tohto
          článku musí obsahovať všetky údaje potrebné na vykonanie a vyúčtovanie
          prepravy tak, aby mohla po prijatí plniť funkciu Zmluvy o preprave,
          najmä a) označenie strán (Odosielateľ a Dopravca), presné adresy,
          telefón príp. e-mail, b) určenie času čas nakládky, miesto nakládky d)
          odplatu za vykonanú prepravu v zmysle cenníka platného ku dňu
          vykonania objednávky, e) súhlas odosielateľa s Prepravným poriadkom.
          3.3 K uzavretiu Zmluvy o preprave dochádza okamžikom potvrdenia
          objednávky odosielateľa Dopravcom. Objednávka je záväzná pre
          odosielateľa, aj keď je dohodnutá telefonicky a potvrdená Dopravcom
          telefonicky. V prípade zrušenia objednávky zo strany odosielateľa po
          pristavení vozidla na nakládku má Dopravca nárok na náhradu vzniknutej
          škody a ušlého zisku. Náhrada škody sa vypočíta ako počet vykázaných
          km od výjazdu vozidla zo stanovišťa po miesto nakládky a spať
          vynásobený sadzbou za 1 km podľa cenníka platného ku dňu prepravy. 3.4
          Zmluvou o preprave sa Dopravca zaväzuje objednávateľovi, že vykoná
          prepravu zásielky z určitého miesta (miesto odoslania) do najbližšej
          čističky odpadových vôd za podmienok ustanovených týmto Prepravným
          poriadkom a odosielateľ sa Dopravcovi zaväzuje, že splní dohodnuté a
          Prepravným poriadkom ustanovené podmienky a zaplatí prepravné. 3.5
          Vykonaním prepravy a ostatných úkonov až do miesta určenia
          uskutočnených na splnenie Zmluvy o preprave Dopravcovi prislúcha
          prepravné. Výška prepravného a doba splatnosti sa dohodne záznamom v
          potvrdenej objednávke, v Zmluve o preprave prípadne akceptovaním
          aktuálneho cenníka, ktorý k dispozícii na webovom sídle spoločnosti.
          Obdobne sa dohodne aj forma úhrady. Okrem prepravného Dopravca počíta
          hotové výdavky potrebné na uskutočnenie prepravy zásielky až do miesta
          určenia alebo vynaložené z príkazu alebo v záujme odosielateľa alebo
          ním poverenej osoby. 3.6 V prípade omeškania úhrad podľa dohodnutej
          splatnosti zmluvných strán platí povinná strana úroky z omeškania vo
          výške 0, 5% z dlžnej sumy za každý deň omeškania. 3.10 Ak nevyplýva zo
          Zmluvy o preprave niečo iné, Zmluva o preprave zaniká vyprázdnením
          nádoby vozidla na ČOV.
        </p>
        <p>
          4) Práva a povinnosti odosielateľa a príjemcu 4.1 Odosielateľ zásielky
          zodpovedá za škodu spôsobenú Dopravcovi uvedením nesprávnych údajov
          najmä informácii o pôvode znečistenia odpadových vôd, nesprávnej
          hustote odpadových vôd, iného materiálu v odpadových vodách (kamene,
          kov a pod) 4.2. Odosielateľ je povinný informovať Dopravcu o možnom
          znečistení prepravovaných odpadových vôd, prípadne ak vzdialenosť
          zásobníka odpadových vôd od prístupovej cesty nezodpovedá možnostiam
          Dopravcu (25 m hadice). 4.3 Ak zásielka nezodpovedá ustanoveniu odseku
          1 a 2 tohto článku, Dopravca môže jej prijatie odmietnuť; uskutočnený
          príjazd a odjazd a s tým spojenú stratu času je odosielateľ povinný
          Dopravcovi uhradiť. Odmietnutie prevzatia zásielky je Dopravca povinný
          odosielateľovi odôvodniť. Ak je možné nedostatky zásielky odstrániť
          bez väčších výdavkov, tak je Dopravca oprávnený, ale nie je povinný
          tieto nedostatky na náklady odosielateľa zásielky odstrániť.
        </p>
        <p>
          5) Vylúčenie z prepravy Preprava sa vykonáva s vylúčením nasledovných
          vecí: - nebezpečných odpadov,
        </p>
        <p>
          6) Osobitné povinnosti odosielateľa, prijímateľa a Dopravcu 6.1
          Dopravca zodpovedá za konanie a opomenutie svojich zástupcov a
          zamestnancov a všetkých ostatných osôb, ktoré použije pri
          uskutočňovaní prepravy, ako za vlastné konanie alebo opomenutie. 6.2
          Dopravca je povinný prepravu vykonať do miesta určenia s odbornou
          starostlivosťou bez zbytočného odkladu. 6.4 Dopravca môže svoj záväzok
          plniť pomocou ďalšieho dopravcu a zodpovedá pritom, akoby prepravu
          uskutočňoval sám. 6.5 Odosielatelia zásielok pri opakujúcich sa
          prepravách z rovnakého miesta nakládky zabezpečia podmienky pre
          bezpečnosť práce a zdravia pri práci pri týchto úkonoch. Zabezpečia,
          aby sa nakladacie miesta a zariadenia udržiavali v stave, ktorý
          umožňuje rýchlu a bezpečnú nakládku, zabezpečiť dostatočné spevnenie
          všetkých plôch používaných na jazdu vozidiel vrátane neverejných
          príchodových ciest a ich udržiavanie v bezpečne zjazdnom stave, ako aj
          dostatočné osvetlenie pracovísk.
        </p>
        <p>
          7) Hmotnosť zásielky, preťaženie 7.1 Dopravca je zodpovedný za to, aby
          vozidlo bolo naložené len v rámci celkovej povolenej hmotnosti
          vozidla. .
        </p>
        <p>
          8) Čas čakania 8.1 Pre čas čakania sa počíta dohodnutá náhrada. Za čas
          čakania sa považuje čas od pristavenia vozidla k nakládke až do
          ukončenia nakládky a odovzdanie potrebných dokumentov vodičovi
          odosielateľom. 8.2 Za každých začatých 15 min. je Dopravca oprávnený
          účtovať odosielateľovi prepravy poplatok podľa platného cenníka.
        </p>
        <p>
          9) Zodpovednosť dopravcu 9.1 Dopravca zodpovedá za škodu na zásielke,
          ktorá vznikla po jej prevzatí až do jej vydania príjemcovi, ibaže ju
          Dopravca nemohol odvrátiť pri vynaložení odbornej starostlivosti. 9.2
          Pri škode na zásielke vzniknutej podľa bodu 1 tohto článku je Dopravca
          povinný vynaložiť odbornú starostlivosť, aby škoda bola čo najmenšia.
          9.3 Pri nárokoch na náhradu škodu je potrebné podať z miesta nároku
          potrebné doklady o príčine a výške škody - najmä nákladný list. Pre
          stanovenie výšky škody je potrebné, aby poškodený predložil faktúry,
          ak sú k dispozícii, ako aj výpočet výšky škody a iné doklady
          dokazujúce nárok na náhradu.
        </p>
        <p>
          10) Prepravné listiny 10.1 Dopravca je oprávnený požadovať, aby mu
          odosielateľ potvrdil požadovanú prepravu v prepravnom doklade, a
          odosielateľ je oprávnený požadovať, aby mu Dopravca písomne potvrdil
          prevzatie zásielky resp. prepravnom liste. 11.2 Prepravnou listinou v
          cestnej nákladnej doprave je: - denný záznam o prevádzke vozidla -
          STAZ-ka 11.3 Prepravná listina – denný záznam o prevádzke vozidla musí
          obsahovať najmenej tieto údaje: a) názov – meno – odosielateľa a
          príjemcu d) celkový objem zásielky e) miesto nakládky a miesto
          vykládky f) dátum a potvrdenie prevzatia zásielky Dopravcom. 11.4
          Dopravca a Odosielateľ zodpovedajú za správnosť a úplnosť údajov,
          ktoré zapisujú do prepravnej listiny. 11.5 Za zničený alebo stratený
          náložný list je povinný dopravca vydať odosielateľovi nový náložný
          list s vyznačením, že ide o náhradný náložný list. V prípade zneužitia
          pôvodného náložného listu je odosielateľ povinný uhradiť škodu, ktorá
          tým bola dopravcovi spôsobená. 11.6 Obsah náložného listu je rozhodný
          pre nároky osoby oprávnenej podľa náložného listu. Dopravca sa môže
          voči nej odvolávať na ustanovenia zmluvy uzavretej s odosielateľom,
          len pokiaľ sú obsiahnuté v náložnom liste alebo pokiaľ sa na tieto
          ustanovenia v ňom výslovne odkazuje. Voči osobe oprávnenej podľa
          náložného listu môže dopravca uplatniť len námietky, ktoré vyplývajú z
          obsahu náložného listu alebo zo vzťahu dopravcu k oprávnenej osobe.
        </p>
        <p>
          11) Ako postupovať v prípade nehody a iných mimoriadnych udalostí 11.1
          Postup pri dopravných nehodách a likvidácia následkov je závislá na
          rozsahu nehody, t.j. na stupni poškodenia vlastného vozidla a
          prípadných ďalších vozidiel iných účastníkov nehody, poškodenia iného
          majetku (cestného zariadenia a pod.) a hlavne na zranení osôb a ich
          schopnosti jednať bezprostredne po nehode spôsobom, ktorý zodpovedá
          stavu vecí po nehode. 11.2 Ak bolo nevyhnutné kvôli vyslobodeniu
          zranených osôb pohybovať po nehode s vozidlami, je nutné zaistiť stopy
          konečného postavenia vozidiel po nehode a zapísať si mená a adresy
          svedkov nehody, prípadne evidenčné čísla ich vozidiel. 11.3 Postup
          vodiča, resp. posádky vozidla, ktorá sa zúčastnila dopravnej nehody
          vychádza z § 65 a § 66 Zákona č. 8/2009 Z. z. o cestnej premávke, v
          znení neskorších predpisov. Základnou povinnosťou vodiča, ktorý sa
          zúčastnil dopravnej nehody je: a) bezodkladne zastaviť vozidlo b)
          zdržať sa požitia alkoholického nápoja alebo užitia inej návykovej
          látky po nehode v čase, keď by bolo na ujmu zistenia, či pred jazdou
          alebo počas jazdy požil alkoholický nápoj alebo užil inú návykovú
          látku. 11.4 Povinnosti účastníka dopravnej nehody sú nasledovné: a)
          ohlásiť dopravnú nehodu polícii SR, b) poskytnúť podľa svojich
          schopností a možností zranenej osobe potrebnú prvú pomoc a bezodkladne
          privolať záchrannú zdravotnú službu, c) vykonať potrebné opatrenia na
          záchranu osoby alebo majetku ohrozeného dopravnou nehodou, d) umožniť
          obnovenie cestnej premávky, najmä premávky vozidiel pravidelnej
          verejnej dopravy osôb, e) preukázať svoju totožnosť na požiadanie
          iného účastníka dopravnej nehody, f) bezodkladne a pokiaľ možno na
          mieste upovedomiť osobu, ktorá nie je účastníkom dopravnej nehody o
          hmotnej škode, ak tejto osobe bola pri nehode spôsobená hmotná škoda a
          oznámiť jej svoje osobné údaje; ak to nie je možné, upovedomenie a
          oznámenie zabezpečí prostredníctvom policajného zboru, g) urobiť
          vhodné opatrenia, aby nebola ohrozená bezpečnosť cestnej premávky na
          mieste dopravnej nehody, h) zotrvať na mieste dopravnej nehody až do
          príchodu policajta alebo sa na toto miesto bezodkladne vrátiť po
          poskytnutí alebo privolaní pomoci, alebo po ohlásení dopravnej nehody,
          i) zdržať sa konania, ktoré by bolo na ujmu vyšetrenia dopravnej
          nehody, najmä premiestnenia vozidiel. 11.5 Ak pri dopravnej nehode
          došlo k usmrteniu osoby alebo k jej zraneniu, ak došlo k poškodeniu
          cesty alebo všeobecne prospešného zariadenia, ak unikli nebezpečné
          látky alebo ak na niektorom zo zúčastnených vozidiel vrátane
          prepravovaných veci alebo na inom majetku vznikla hmotná škoda zrejme
          prevyšujúca desaťnásobok minimálnej mzdy zamestnanca odmeňovaného
          mesačnou mzdou ustanovenou osobitným predpisom , účastník dopravnej
          nehody je povinný: a) ohlásiť bezodkladne dopravnú nehodu polícii SR
          b) zotrvať na mieste dopravnej nehody až po príchod policajta alebo sa
          na toto miesto bezodkladne vrátiť po poskytnutí alebo privolaní pomoci
          alebo po ohlásení dopravnej nehody c) zdržať sa konania, ktoré by bolo
          na ujmu vyšetrenia dopravnej nehody, najmä premiestnenia vozidiel. Ak
          sa situácia, ktorá vznikla dopravnou nehodou musí zmeniť, najmä ak je
          to potrebné na uvoľnenie alebo ošetrenie zranenej osoby, alebo na
          obnovenie premávky predovšetkým vozidiel hromadnej prepravy osôb,
          účastník dopravnej nehody je povinný vyznačiť situáciu a stopy. 11.6
          Ak škoda spôsobená pri dopravnej nehode na žiadnom zo zúčastnených
          vozidiel vrátane prepravovaných vecí ani na inom majetku nedosiahla
          výšku ustanovenú v odseku 5, účastníci dopravnej nehody sú povinní
          postupovať podľa odseku 5, len ak sa výslovne nedohodlo inak. 11.7
          Posádka je náležite poučená ako postupovať v prípade požiaru vozidla.
          Vozidlá sú vybavené predpísanými hasiacimi prístrojmi. 11.8 Dopravca
          má v prípade znečistenia alebo poškodenia komunikácie jeho vozidlami
          povinnosť bez meškania odstrániť znečistenie alebo poškodenia a uviesť
          komunikáciu do pôvodného stavu. Ak odstránenie znečistenia alebo
          poškodenia nie je v jeho možnostiach, je povinný to nahlásiť správcovi
          komunikácie a uhradiť mu následné náklady spojené s odstránením
          znečistenia a s uvedením do pôvodného stavu.
        </p>
        <p>
          12) Reklamačné konanie 12.1 Reklamačné lehoty a premlčacie doby na
          uplatňovanie nárokov odosielateľa vyplývajúce zo Zmluvy o preprave s
          Dopravcom sú uvedené pre vnútroštátnu cestnú nákladnú dopravu
          vykonávanú v Slovenskej republike v Obchodnom zákonníku. Oprávnený
          musí reklamovať u Dopravcu všetky práva vyplývajúce z prepravy
          písomne. 12.2 Vrátenie zaplatenej sumy za prepravu je oprávnený
          odosielateľ) žiadať len ak ju preukázateľne Dopravcovi uhradil.
        </p>
        <p>
          13) Záverečné ustanovenia 13.1 Všetky zmeny a doplnky Prepravného
          poriadku sú platné dňom ich zverejnenia a sprístupnenia na webovom
          sídle Dopravcu. 13.2 Dopravca zverejnil tento Prepravný poriadok na
          svojom webovom sídle. 13.3 Tento prepravný poriadok nadobúda platnosť
          dňom 01.09.2022. 13.4 Každý prepravca (odosielateľ a príjemca
          zásielky) je povinný pred podpisom Zmluvy o preprave sa s týmto
          poriadkom oboznámiť.
        </p>
      </header>
    </div>
  );
}

export default App;
